<template>
  <Modal title="编辑用户信息" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
      <Form ref="agent"  :model='agent' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <form-item label="所属地区" prop="area">
          <Cascader :data="treeSelect" trigger="hover" v-model="agent.area"
                    @on-change="selectCate"></Cascader>
        </form-item>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" @click="handleOk('agent')"  :loading="loading">
        <span v-if="!loading">提交</span>
        <span v-else>提交中...</span>
      </Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
import { regionInfo, addArea, agentInfo } from '@/api/agent'
export default {
  name: 'userEdit',
  props: ['id'],
  data () {
    return {
      isShow: false,
      agent_area_id: 0,
      loading: false,
      treeSelect: [],
      agent: {
        agent_id: 0,
        area: [],
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    id (val) {
      this.agent_area_id = val
      if (this.agent_area_id > 0) {
        this.agentInfo(this.agent_area_id)
      }
    }
  },
  created () {
    this.regionInfo()
  },
  methods: {
    regionInfo () {
      regionInfo().then(res => {
        this.treeSelect = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    handle (status) {
      this.isShow = false
    },
    selectCate (val) {
      this.agent.area = val
    },
    handleOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          addArea(this.agent).then(res => {
            let msg = '添加成功'
            if (this.agent.agent_id > 0) {
              msg = '编辑成功'
            }
            if (res.code === 200) {
              this.$Message.success(msg)
              this.$emit('updateStatusModel')
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
            this.loading = false
          })
        }
      })
    },
    agentInfo (id) {
      agentInfo(id).then(res => {
        this.agent = res.data
        if(this.agent.pro_id != 0){
          this.agent.area = [this.agent.pro_id,this.agent.city_id,this.agent.area_id];
        }

        // console.log(this.agent.area)
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    }
  }
}
</script>
